import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { UserDto } from "@/core/features/users/user.dto";
import { OperativeUnitDto } from "@/core/features/operative-units/operative-unit.dto";
import { toEuros } from "@/utils/numberUtils";
import { FileDto } from "@/core/features/file/file.dto";
import { InvoiceStatusEnum, InvoiceDocumentTypeEnum } from "@altertec_gparn/lib";
import { CertificationHasInvoiceDto } from "@/core/features/certifications-have-invoices/certification-has-invoice.dto";
import { ClientDto } from "@/core/features/clients/client.dto";
import { CompanyDto } from "@/core/features/companies/company.dto";
import { BankDto } from "@/core/features/banks/bank.dto";
import {
  getInvoiceAllocatedAmountForCertification,
  getInvoiceUnallocatedAmount,
} from "@/modules/invoices/utils/invoice-allocation.utils";
import { InvoiceLineDto } from "./invoice-line.dto";

export class InvoiceDto extends BaseEntityDto {
  numeration: string;

  deliveryNumeration?: string;

  status?: InvoiceStatusEnum;

  type?: InvoiceDocumentTypeEnum;

  @Type(() => InvoiceDto)
  referencedInvoice?: InvoiceDto;

  referencedInvoiceId?: string | null;

  @Transform(({ value }) => parseApiDate(value))
  date?: Date;

  @Transform(({ value }) => parseApiDate(value))
  creationDate: Date;

  @Type(() => CertificationHasInvoiceDto)
  certificationHasInvoices?: CertificationHasInvoiceDto[];

  @Type(() => InvoiceLineDto)
  lines?: InvoiceLineDto[];

  @Type(() => UserDto)
  author: UserDto;
  authorId: string;

  @Transform(({ value }) => toEuros(value))
  amount?: number;

  @Transform(({ value }) => toEuros(value))
  totalAmount: number;

  vatType?: number;

  @Transform(({ value }) => toEuros(value))
  vatAmount?: number;

  withholdingType?: number;

  @Transform(({ value }) => toEuros(value))
  withholdingAmount?: number;

  @Transform(({ value }) => parseApiDate(value))
  dueDate?: Date;

  @Transform(({ value }) => parseApiDate(value))
  paymentDate?: Date;

  deliveredTo?: string | null;

  orderCode?: string;

  accountingComment?: string | null;

  @Type(() => OperativeUnitDto)
  operativeUnit?: OperativeUnitDto;
  operativeUnitId: string;

  @Type(() => ClientDto)
  client?: ClientDto;
  clientId?: string;

  @Type(() => CompanyDto)
  company?: CompanyDto;
  companyId?: string;

  @Type(() => BankDto)
  bank?: BankDto;
  bankId?: string;

  canBeAdvanced?: boolean;

  @Type(() => FileDto)
  files: FileDto[];

  getClientName(): string | undefined {
    return this.client?.name;
  }

  getClientVatNumber(): string | undefined {
    return this.client?.vatNumber;
  }

  getAllocatedAmountForCertification(certificationId: string): number | undefined {
    return getInvoiceAllocatedAmountForCertification(this, certificationId);
  }

  getUnallocatedAmount(): number {
    return getInvoiceUnallocatedAmount(this);
  }
}
